const hostList = [
    {
        host: 'clinsev',
        ymID: 55241896
    },
    {
        host: 'clinokt',
        ymID: 94184676
    }
];

const goals = [
    {
        goal: ['form_from_header', 'first_step'],
        selector: "[data-goal='go-to-appointment-page-from-header']"
    },
    {
        goal: ['form_from_employees', 'first_step', 'knopka-zapisatsya'],
        selector: "[data-goal='go-to-appointment-page-from-employees-page']"
    },
    {
        goal: ['form_from_employee', 'first_step', 'knopka-zapisatsya'],
        selector: "[data-goal='go-to-appointment-page-from-employee-page']"
    },
    {
        goal: ['form_from_service', 'first_step'],
        selector: "[data-goal='go-to-appointment-page-from-service-page']"
    },
    {
        goal: ['second_step'],
        selector: ''
    },
    {
        goal: ['specialist_choice'],
        selector: ''
    },
    {
        goal: ['time_choice'],
        selector: ''
    },
    {
        goal: ['service_choice'],
        selector: ''
    },
    {
        goal: ['sixth_step'],
        selector: ''
    },
    {
        goal: ['press_send_code', 'otpravit-kod'],
        selector: "[data-goal='request-code-on-phone']"
    },
    {
        goal: ['successful_appointment'],
        selector: ''
    },
    {
        goal: ['perekhod-na-stranicu-specialista'],
        selector: "[data-goal='redirect-to-specialist-page']"
    },
    {
        goal: ['perekhod-na-stranicu-stati'],
        selector: "[data-goal='redirect-to-article-page']"
    },
    {
        goal: ['perekhod-na-stranicu-uslugi'],
        selector: "[data-goal='redirect-to-service-page']"
    },
    {
        goal: ['knopka-dalee'],
        selector: "[data-goal='accept-service-continue-appointment']"
    },
    {
        goal: ['knopka-podtverdit'],
        selector: "[data-goal='accept-code-from-phone']"
    }
];

let activeBranchOffice = null;

export function dispatchGoalEvent(goal, data = {}) {
    window.dispatchEvent(
        new CustomEvent('ajax-form-complete', {
            detail: {
                ...data,
                ym: {
                    goal: goal
                }
            }
        })
    );
}

document.addEventListener('DOMContentLoaded', function() {
    activeBranchOffice = identifyBranchOffice();
    if (!activeBranchOffice) {
        window.sendGoal = function(goals, ymID) {
            console.log(goals, ymID);
        };
        return;
    }

    function initGoalsListener() {
        document.addEventListener('click', goalsHandler);
    }

    function goalsHandler(e) {
        const goal = goals.find(function(item) {
            return item.selector && e.target.closest(item.selector);
        });
        if (goal) {
            sendGoal(goal.goal);
        }
    }

    function sendGoal(goals, ymID) {
        if (typeof ym === 'undefined') return;
        if (!ymID) {
            ymID = activeBranchOffice.ymID;
        }
        goals.forEach(function(goal) {
            ym(ymID, 'reachGoal', goal);
        });
    }
    window.sendGoal = sendGoal;

    function identifyBranchOffice() {
        const domain = getDomain(window.location.host);

        let branchOfficeData = null;
        for (let i = 0; i < hostList.length; i++) {
            if (domain === hostList[i].host) {
                branchOfficeData = hostList[i];
                branchOfficeData.index = i;
                return branchOfficeData;
            }
        }
        return branchOfficeData;
    }
    initGoalsListener();

    window.addEventListener('ajax-form-complete', function(e) {
        if (e.detail.ym && e.detail.ym.goal) {
            sendGoal([e.detail.ym.goal]);
        }
    });
});

function getDomain(host) {
    let domainParts = host.split('.');

    domainParts = domainParts.slice(0, domainParts.length - 1);

    return domainParts.join('.');
}
